import React from 'react';

/* ─── SVG Icon helper ─── */
// Updated to handle both path strings and React elements/Fragments
export const Ic = ({ d, size = 20, color = "currentColor", sw = 1.6, fill = "none" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill={fill} 
      stroke={color} 
      strokeWidth={sw} 
      strokeLinecap="round" 
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
    >
      {typeof d === "string" ? <path d={d} /> : d}
    </svg>
  );
};

export const icons = {
  // Linux: Keeping your custom component structure
  linux: (
    <svg width="100%" height="100%" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <g transform="matrix(2.2 0 0 2.2 256 256)">
        <path d="M-32-25c-3 7-24 29-22 51 8 92 36 30 78 53 0 0 75-42 15-110-17-24-2-43-13-59s-30-17-44-2 6 37-14 67" fill="#333"/>
        <path d="M42 21s9-18-8-31c16 17 6 32 6 32h-3C36-13 27 6 14-56 29-73 0-88 0-60h-9c1-24-20-12-8 5-1 37-23 52-23 78-7-18 6-32 6-32s-18 15-7 37 31 17 17 27c22 15 56 5 55-27 1-8 22-5 24-3s-3-4-13-4m-56-78c-7-2-5-11-2-11s8 7 2 11m19 1c-5-7-1-14 4-13s5 13-4 13" fill="#eee"/>
        <path d="M-41 31l21 30c11 7 5 35-25 21-17-5-31-4-33-13s4-10 3-14c-4-22 14-11 19-22s5-16 15-2 M71 45c-4-6 0-17-14-16-6 12-23 24-24 0-10 0-3 24-7 35-9 27 17 29 28 16l26-18c2-3 5-6-9-17 m-92-92c-3-6 11-14 16-14s12 4 19 6 4 9 2 10S3-35-5-35s-10-8-16-12 M-21-48c8 6 17 11 35-3" fill="#fc2"/>
        <path d="M-10-54c-2 0 1-2 2-1 m7 1c1-1-1-2-3-1" fill="#333"/>
      </g>
    </svg>
  ),

  js: (
    <svg width="100%" height="100%" viewBox="0 0 32 32">
      <rect x="2" y="2" width="28" height="28" fill="#f5de19" />
      <path d="M20.809,23.875a2.866,2.866,0,0,0,2.6,1.6c1.09,0,1.787-.545,1.787-1.3,0-.9-.716-1.222-1.916-1.747l-.658-.282c-1.9-.809-3.16-1.822-3.16-3.964,0-1.973,1.5-3.476,3.853-3.476a3.889,3.889,0,0,1,3.742,2.107L25,18.128A1.789,1.789,0,0,0,23.311,17a1.145,1.145,0,0,0-1.259,1.128c0,.789.489,1.109,1.618,1.6l.658.282c2.236.959,3.5,1.936,3.5,4.133,0,2.369-1.861,3.667-4.36,3.667a5.055,5.055,0,0,1-4.795-2.691Zm-9.295.228c.413.733.789,1.353,1.693,1.353.864,0,1.41-.338,1.41-1.653V14.856h2.631v8.982c0,2.724-1.6,3.964-3.929,3.964a4.085,4.085,0,0,1-3.947-2.4Z" fill="#333"/>
    </svg>
  ),

  python: (
    <svg width="100%" height="100%" viewBox="0 0 32 32">
      <path fill="#3776AB" d="M13.016 2C10.82 2 9.038 3.725 9.038 5.852V8.519h6.885v.74H5.978C3.781 9.26 2 10.984 2 13.111v5.778c0 2.127 1.781 3.852 3.978 3.852h2.295V19.48c0-2.127 1.781-3.852 3.978-3.852h7.344c1.86 0 3.366-1.46 3.366-3.26V5.852C22.96 3.725 21.18 2 18.984 2h-5.968ZM12.1 6.74a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7Z"/>
      <path fill="#FFD43B" d="M18.983 30c2.2 0 3.978-1.725 3.978-3.852v-2.666h-6.885v-.741h9.945c2.2 0 3.978-1.725 3.978-3.852v-5.778c0-2.127-1.781-3.852-3.978-3.852h-2.295v3.259c0 2.127-1.781 3.852-3.978 3.852h-7.344c-1.86 0-3.366 1.46-3.366 3.26v6.519c0 2.127 1.781 3.852 3.978 3.852h5.968ZM19.9 25.26a1.35 1.35 0 1 1 0 2.7 1.35 1.35 0 0 1 0-2.7Z"/>
    </svg>
  ),

  apple: (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47 4.25 17 2.94 12.45 4.7 9.39 5.57 7.87 7.13 6.91 8.82 6.88 10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z"/>
    </svg>
  ),

  windows: (
    <svg width="100%" height="100%" viewBox="0 0 24 24">
      <rect x="3" y="3" width="8.5" height="8.5" fill="#F25022"/>
      <rect x="12.5" y="3" width="8.5" height="8.5" fill="#7FBA00"/>
      <rect x="3" y="12.5" width="8.5" height="8.5" fill="#00A4EF"/>
      <rect x="12.5" y="12.5" width="8.5" height="8.5" fill="#FFB900"/>
    </svg>
  ),
  
  react: (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.6789 15.9759C18.6789 14.5415 17.4796 13.3785 16 13.3785C14.5206 13.3785 13.3211 14.5415 13.3211 15.9759C13.3211 17.4105 14.5206 18.5734 16 18.5734C17.4796 18.5734 18.6789 17.4105 18.6789 15.9759Z" fill="#53C1DE"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M24.7004 11.1537C25.2661 8.92478 25.9772 4.79148 23.4704 3.39016C20.9753 1.99495 17.7284 4.66843 16.0139 6.27318C14.3044 4.68442 10.9663 2.02237 8.46163 3.42814C5.96751 4.82803 6.73664 8.8928 7.3149 11.1357C4.98831 11.7764 1 13.1564 1 15.9759C1 18.7874 4.98416 20.2888 7.29698 20.9289C6.71658 23.1842 5.98596 27.1909 8.48327 28.5877C10.9973 29.9932 14.325 27.3945 16.0554 25.7722C17.7809 27.3864 20.9966 30.0021 23.4922 28.6014C25.9956 27.1963 25.3436 23.1184 24.7653 20.8625C27.0073 20.221 31 18.7523 31 15.9759C31 13.1835 26.9903 11.7923 24.7004 11.1537ZM24.4162 19.667C24.0365 18.5016 23.524 17.2623 22.8971 15.9821C23.4955 14.7321 23.9881 13.5088 24.3572 12.3509C26.0359 12.8228 29.7185 13.9013 29.7185 15.9759C29.7185 18.07 26.1846 19.1587 24.4162 19.667ZM22.85 27.526C20.988 28.571 18.2221 26.0696 16.9478 24.8809C17.7932 23.9844 18.638 22.9422 19.4625 21.7849C20.9129 21.6602 22.283 21.4562 23.5256 21.1777C23.9326 22.7734 24.7202 26.4763 22.85 27.526ZM9.12362 27.5111C7.26143 26.47 8.11258 22.8946 8.53957 21.2333C9.76834 21.4969 11.1286 21.6865 12.5824 21.8008C13.4123 22.9332 14.2816 23.9741 15.1576 24.8857C14.0753 25.9008 10.9945 28.557 9.12362 27.5111ZM2.28149 15.9759C2.28149 13.874 5.94207 12.8033 7.65904 12.3326C8.03451 13.5165 8.52695 14.7544 9.12123 16.0062C8.51925 17.2766 8.01977 18.5341 7.64085 19.732C6.00369 19.2776 2.28149 18.0791 2.28149 15.9759ZM9.1037 4.50354C10.9735 3.45416 13.8747 6.00983 15.1159 7.16013C14.2444 8.06754 13.3831 9.1006 12.5603 10.2265C11.1494 10.3533 9.79875 10.5569 8.55709 10.8297C8.09125 9.02071 7.23592 5.55179 9.1037 4.50354ZM20.3793 11.5771C21.3365 11.6942 22.2536 11.85 23.1147 12.0406C22.8562 12.844 22.534 13.6841 22.1545 14.5453C21.6044 13.5333 21.0139 12.5416 20.3793 11.5771ZM16.0143 8.0481C16.6054 8.66897 17.1974 9.3623 17.7798 10.1145C16.5985 10.0603 15.4153 10.0601 14.234 10.1137C14.8169 9.36848 15.414 8.67618 16.0143 8.0481ZM9.8565 14.5444C9.48329 13.6862 9.16398 12.8424 8.90322 12.0275C9.75918 11.8418 10.672 11.69 11.623 11.5748C10.9866 12.5372 10.3971 13.5285 9.8565 14.5444ZM11.6503 20.4657C10.6679 20.3594 9.74126 20.2153 8.88556 20.0347C9.15044 19.2055 9.47678 18.3435 9.85796 17.4668C10.406 18.4933 11.0045 19.4942 11.6503 20.4657ZM16.0498 23.9915C15.4424 23.356 14.8365 22.6531 14.2448 21.8971C15.4328 21.9423 16.6231 21.9424 17.811 21.891C17.2268 22.6608 16.6369 23.3647 16.0498 23.9915ZM22.1667 17.4222C22.5677 18.3084 22.9057 19.1657 23.1742 19.9809C22.3043 20.1734 21.3652 20.3284 20.3757 20.4435C21.015 19.4607 21.6149 18.4536 22.1667 17.4222ZM18.7473 20.5941C16.9301 20.72 15.1016 20.7186 13.2838 20.6044C12.2509 19.1415 11.3314 17.603 10.5377 16.0058C11.3276 14.4119 12.2404 12.8764 13.2684 11.4158C15.0875 11.2825 16.9178 11.2821 18.7369 11.4166C19.7561 12.8771 20.6675 14.4086 21.4757 15.9881C20.6771 17.5812 19.7595 19.1198 18.7473 20.5941ZM22.8303 4.4666C24.7006 5.51254 23.8681 9.22726 23.4595 10.8426C22.2149 10.5641 20.8633 10.3569 19.4483 10.2281C18.6239 9.09004 17.7698 8.05518 16.9124 7.15949C18.1695 5.98441 20.9781 3.43089 22.8303 4.4666Z" fill="#53C1DE"/>
    </svg>
  ),

  flutter: (
    <svg width="100%" height="100%" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <polyline points="15.383 18.316 18.744 15.042 27.093 15.042 19.697 22.438 15.383 18.316 15.383 18.316 15.383 18.316 15.383 18.316 15.383 18.316" fill="#40d0fd"/>
      <polygon points="4.907 16.125 9.106 20.424 27.093 2.287 18.744 2.287 4.907 16.125" fill="#41d0fd" style={{ isolation: "isolate" }}/>
      <polygon points="11.176 22.479 15.435 26.675 19.697 22.438 15.383 18.316 11.176 22.479" fill="#1fbcfd"/>
      <polygon points="15.435 26.675 19.697 22.438 26.989 29.813 18.593 29.813 15.435 26.675" fill="#095a9d"/>
      <polygon points="15.435 26.675 19.406 25.354 18.068 24.057 15.435 26.675" fill="#0e5199"/>
    </svg>
  ),

  chip: (
    <>
      {/* Main chip body */}
      <rect x="6" y="6" width="12" height="12" rx="2.5" />

      {/* Pins top */}
      <line x1="8.5" y1="2" x2="8.5" y2="6" />
      <line x1="12" y1="2" x2="12" y2="6" />
      <line x1="15.5" y1="2" x2="15.5" y2="6" />

      {/* Pins bottom */}
      <line x1="8.5" y1="18" x2="8.5" y2="22" />
      <line x1="12" y1="18" x2="12" y2="22" />
      <line x1="15.5" y1="18" x2="15.5" y2="22" />

      {/* Pins left */}
      <line x1="2" y1="8.5" x2="6" y2="8.5" />
      <line x1="2" y1="12" x2="6" y2="12" />
      <line x1="2" y1="15.5" x2="6" y2="15.5" />

      {/* Pins right */}
      <line x1="18" y1="8.5" x2="22" y2="8.5" />
      <line x1="18" y1="12" x2="22" y2="12" />
      <line x1="18" y1="15.5" x2="22" y2="15.5" />

      {/* Inner core */}
      <rect x="9" y="9" width="6" height="6" rx="1.2" />
    </>
  ),

  software: (
    <>
      {/* Window */}
      <rect x="3" y="4" width="18" height="16" rx="2.5" />

      {/* Top bar */}
      <line x1="3" y1="8" x2="21" y2="8" />

      {/* Window dots */}
      <circle cx="6" cy="6" r="0.8" fill="currentColor" stroke="none" />
      <circle cx="9" cy="6" r="0.8" fill="currentColor" stroke="none" />
      <circle cx="12" cy="6" r="0.8" fill="currentColor" stroke="none" />

      {/* Code brackets */}
      <polyline points="10 11 7 14 10 17" />
      <polyline points="14 11 17 14 14 17" />

      {/* Center slash */}
      <line x1="13" y1="10" x2="11" y2="18" />
    </>
  ),

  appFeatures: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="4" />
      <path d="M8.2 9.2h7.6" />
      <path d="M8.2 14.8h3.6" />
      <path d="M14.4 15.1l1.2 1.2 2.3-3" />
      <path d="M17.2 3v2" />
      <path d="M21 6.8h-2" />
    </>
  ),

  stack: (
    <>
      {/* Outer frame */}
      <rect x="4" y="5" width="16" height="14" rx="3" />

      {/* Top layer */}
      <line x1="8" y1="10" x2="16" y2="10" />

      {/* Bottom layer */}
      <line x1="8" y1="14" x2="13" y2="14" />

      {/* Minimal node */}
      <circle cx="16" cy="14" r="1" fill="currentColor" stroke="none" />
    </>
  ),

  users: (
    <>
      {/* Left person */}
      <circle cx="8" cy="9" r="2" />
      <path d="M5.5 17c0-2 1.6-3.5 3.5-3.5s3.5 1.5 3.5 3.5" />

      {/* Right person */}
      <circle cx="16" cy="9" r="2" />
      <path d="M12.5 17c0-2 1.6-3.5 3.5-3.5s3.5 1.5 3.5 3.5" />
    </>
  ),

  ateno: (
    <>
      {/* Top bar */}
      <rect x="6" y="5" width="12" height="5" rx="2.5" />

      {/* Bottom bar */}
      <rect x="4" y="14" width="16" height="5" rx="2.5" />
    </>
  ),
  
  kitchen: (
    <>
      {/* Hood lamp */}
      <path d="M7 4h3v2H7z" />
      <path d="M5 6h7l3.5 4H1.5z" />

      {/* Counter base */}
      <rect x="1" y="13" width="12" height="7" rx="0.6" />

      {/* Left cabinet */}
      <line x1="1" y1="16" x2="6" y2="16" />
      <line x1="6" y1="13" x2="6" y2="20" />

      {/* Oven */}
      <rect x="7.5" y="14.5" width="3.5" height="4" rx="0.4" />

      {/* Stove burners */}
      <rect x="2" y="11.5" width="2.5" height="0.8" rx="0.3" />
      <rect x="7" y="11.5" width="2.5" height="0.8" rx="0.3" />

      {/* Fridge */}
      <rect x="14" y="6" width="7" height="14" rx="0.6" />
      <line x1="14" y1="12" x2="21" y2="12" />

      {/* Fridge handles */}
      <line x1="15.5" y1="9" x2="15.5" y2="10.5" />
      <line x1="15.5" y1="13.5" x2="15.5" y2="15" />
    </>
  ),

  livingRoom: (
    <>
      {/* Sofa */}
      <path d="M6 12.5a2.5 2.5 0 0 1 2.5-2.5h7A2.5 2.5 0 0 1 18 12.5V17H6z" />

      {/* Sofa cushions */}
      <line x1="12" y1="10.5" x2="12" y2="17" />

      {/* Armrests */}
      <path d="M4 13.5a2 2 0 0 1 2-2V17H4z" />
      <path d="M20 13.5a2 2 0 0 0-2-2V17h2z" />

      {/* Legs */}
      <line x1="8" y1="17" x2="8" y2="20" />
      <line x1="16" y1="17" x2="16" y2="20" />

      {/* Floor lamp */}
      <line x1="20" y1="6" x2="20" y2="20" />
      <path d="M17.5 6.5h5l-1.2 3h-2.6z" />

      {/* Coffee table */}
      <rect x="8.5" y="19" width="7" height="1.8" rx="0.8" />
    </>
  ),

  bedroom: (
    <>
      {/* Bed frame */}
      <rect x="4" y="10" width="16" height="7" rx="1.8" />

      {/* Pillows */}
      <rect x="6" y="11.5" width="3.5" height="2" rx="0.7" />
      <rect x="14.5" y="11.5" width="3.5" height="2" rx="0.7" />

      {/* Headboard */}
      <path d="M4 10V7.5a1.5 1.5 0 0 1 1.5-1.5h13A1.5 1.5 0 0 1 20 7.5V10" />

      {/* Bed legs */}
      <line x1="6" y1="17" x2="6" y2="20" />
      <line x1="18" y1="17" x2="18" y2="20" />

      {/* Nightstand */}
      <rect x="2.5" y="12" width="1.8" height="4" rx="0.5" />

      {/* Lamp */}
      <line x1="3.4" y1="9" x2="3.4" y2="12" />
      <path d="M2.2 8.5h2.4l-.5 1.5h-1.4z" />
    </>
  ),

  bathroom: (
    <>
      {/* Bathtub */}
      <path d="M5 13h14v3.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 16.5z" />

      {/* Tub feet */}
      <line x1="8" y1="19" x2="7" y2="21" />
      <line x1="16" y1="19" x2="17" y2="21" />

      {/* Faucet */}
      <path d="M8 10V7.5a1.5 1.5 0 0 1 1.5-1.5H12" />
      <path d="M12 6h2" />

      {/* Shower */}
      <line x1="18" y1="5" x2="18" y2="10" />
      <path d="M18 5c0-1 1-2 2-2" />

      {/* Water drops */}
      <path d="M16.5 11.5v.01" />
      <path d="M18 12.5v.01" />
      <path d="M19.5 11.5v.01" />

      {/* Mirror */}
      <rect x="4" y="5" width="4" height="4" rx="0.8" />
    </>
  ),

  office: (
    <>
      {/* Desk */}
      <rect x="5" y="12" width="14" height="2.5" rx="1" />

      {/* Desk legs */}
      <line x1="7" y1="14.5" x2="7" y2="20" />
      <line x1="17" y1="14.5" x2="17" y2="20" />

      {/* Monitor */}
      <rect x="8" y="5" width="8" height="5" rx="1" />

      {/* Monitor stand */}
      <line x1="12" y1="10" x2="12" y2="12" />
      <line x1="10" y1="12" x2="14" y2="12" />

      {/* Chair */}
      <path d="M10 17.5a2 2 0 0 1 4 0v1.5h-4z" />
      <line x1="12" y1="19" x2="12" y2="21" />
      <line x1="10.5" y1="21" x2="13.5" y2="21" />

      {/* Small plant */}
      <path d="M19.5 9.5c0-1 1-1.8 2-2 .2 1.4-.3 2.5-1.4 3" />
      <path d="M20 10v2" />
    </>
  ),

  diningRoom: (
    <>
      {/* Table */}
      <rect x="7" y="9" width="10" height="6" rx="2" />

      {/* Table legs */}
      <line x1="9" y1="15" x2="9" y2="20" />
      <line x1="15" y1="15" x2="15" y2="20" />

      {/* Left chair */}
      <path d="M4 10.5h2.5a1 1 0 0 1 1 1V15H4z" />
      <line x1="5" y1="15" x2="5" y2="19" />
      <line x1="7" y1="15" x2="7" y2="19" />

      {/* Right chair */}
      <path d="M17 11.5a1 1 0 0 1 1-1H20v4.5h-3z" />
      <line x1="17" y1="15" x2="17" y2="19" />
      <line x1="19" y1="15" x2="19" y2="19" />

      {/* Pendant lamp */}
      <line x1="12" y1="3" x2="12" y2="6" />
      <path d="M9 6h6l-1 2.5h-4z" />

      {/* Plate */}
      <circle cx="12" cy="12" r="1.2" />
    </>
  ),

  /* ─── UI ICONS (Stored as React JSX to be rendered by Ic) ─── */
  scan:    <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></>,
  cube:    <><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>,
  wand:    <><path d="M15 4V2"/><path d="M15 16v-2"/><path d="M8 9h2"/><path d="M20 9h2"/><path d="M17.8 11.8 19 13"/><path d="M15 9h.01"/><path d="M17.8 6.2 19 5"/><path d="m3 21 9-9"/><path d="M12.2 6.2 11 5"/></>,
  home:    <><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
  check:   <polyline points="20 6 9 17 4 12"/>,
  arrow:   <><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></>,
  shield:  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>,
  lock:    <><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
  eye:     <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
  zap:     <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>,
  code:    <><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></>,
  layers:  <><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></>,
  menu:    <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>,
  star:    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" strokeWidth="0" fill="currentColor"/>,
};
